<template>
  <div class="content center_1">
    <div class="member_box">
      <img class="member_boxbg" src="/static/img/center_memberbg.png" alt />
      <div class="member_info">
        <img :src="member.avatar" alt />
        <p class="member_nickname">{{member.nickname}}</p>
        <p class="member_level">{{member.level_str}}</p>
      </div>
    </div>

    <!--    我的订单-->
    <van-cell
      to="/order"
      title="我的订单"
      value="全部订单"
      title-class="fs_15"
      value-class="fs_12"
      is-link
    />
    <div class="m_order_status mb_5">
      <van-tabbar v-model="active" :fixed="fixed" :z-index="9999">
        <van-tabbar-item :info="totaldaifukuan>0?totaldaifukuan:''" :to="{ path: '/order', query: { status: 0 }}">
          <span>待付款</span>
          <img slot="icon" slot-scope="props" :src="props.active ? icon.daifukuan : icon.daifukuan"/>
        </van-tabbar-item>
        <van-tabbar-item :info="totaldaijiedan>0?totaldaijiedan:''" :to="{ path: '/order', query: { status: 1 }}">
          <span>待接单</span>
          <img slot="icon" slot-scope="props" :src="props.active ? icon.daijiedan : icon.daijiedan"/>
        </van-tabbar-item>
        <van-tabbar-item :info="totaldaifuwu>0?totaldaifuwu:''" :to="{ path: '/order', query: { status: 2 }}">
          <span>待服务</span>
          <img slot="icon" slot-scope="props" :src="props.active ? icon.daifuwu : icon.daifuwu" />
        </van-tabbar-item>
        <van-tabbar-item :info="totalyiwancheng>0?totalyiwancheng:''" :to="{ path: '/order', query: { status: 3 }}">
          <span>已完成</span>
          <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? icon.yiwancheng : icon.yiwancheng"
          />
        </van-tabbar-item>
        <!-- <van-tabbar-item info="3">
        <span>待评价</span>
        <img
          slot="icon"
          slot-scope="props"
          :src="props.active ? icon.daipingjia : icon.daipingjia"
        >
        </van-tabbar-item>-->
        <van-tabbar-item :info="totalyiguanbi>0?totalyiguanbi:''" :to="{ path: '/order', query: { status: -1 }}">
          <span>已取消</span>
          <img
            slot="icon"
            slot-scope="props"
            :src="props.active ? icon.quxiaodingdan : icon.quxiaodingdan"
          />
        </van-tabbar-item>
      </van-tabbar>
    </div>

    <!--    列表-->
    <div class="mb_5">
      <van-cell to="/gorecharge" title="只需199成分享合伙人赚赏金" is-link  v-if="member.isagent == 0">
        <van-icon slot="icon" class="iconfont icon-qianbao col_59AAFF" />
      </van-cell>
      <van-cell
        to="/balance"
        title="我的余额"
        :value="member.credit2"
        is-link
        value-class="col_E97620 fs_15"
      >
        <van-icon slot="icon" class="iconfont icon-yue col_F5C60B" />
      </van-cell>
      <van-cell to="/history" title="浏览记录" is-link>
        <van-icon slot="icon" class="iconfont icon-jilu col_45B9BC" />
      </van-cell>
      <van-cell to="/coupon" title="优惠券" is-link>
        <van-icon slot="icon" class="iconfont icon-youhuiquan01 col_EA6953" />
      </van-cell>
      <van-cell to="/recommend" title="推荐分享" is-link v-if="member.isagent > 0">
        <van-icon slot="icon" class="iconfont icon-tuijianren col_45B9BC" />
      </van-cell>
      <van-cell to="/store_qrcode" title="推荐门店" is-link v-if="member.isagent > 0">
        <van-icon slot="icon" class=" iconfont icon-iconfonterweima col_1EBF9D"/>
      </van-cell>
    </div>
    <div class="mb_5">
      <div v-if="is_tech > 0">
        <van-cell to="/tech_center" title="技师中心" is-link>
          <van-icon slot="icon" class="iconfont icon-jishi col_EA6953" />
        </van-cell>
      </div>
      <div v-if="is_store > 0">
        <van-cell to="/storeCenter" title="门店中心" is-link>
          <van-icon slot="icon" class="iconfont icon-mendianguanli col_45B9BC" />
        </van-cell>
      </div>
    </div>

    <div class="enter_apply" v-if="is_tech==0 || is_store == 0">
      <!-- <div class="enter_apply"> -->
      <router-link :to="{path: '/apply',query:{is_tech:is_tech,is_store:is_store}}">
      <img src="/static/img/center_recruit.png"  alt />
      </router-link>
    </div>

    <!--底部固定导航-->
    <tab-bar :center-active="'active'" :center-icon="'/static/img/icon_nav55.png'"></tab-bar>
  </div>
</template>

<script>
import tabBar from "@/components/tabBar.vue";

export default {
  name: "center_1",
  components: { tabBar },
  data() {
    return {
      active: "",
      icon: {
        daifukuan: "/static/img/center_daifukuan.png",
        daifuwu: "/static/img/center_daifuwu.png",
        daijiedan: "/static/img/center_daijiedan.png",
        yiwancheng: "/static/img/center_yiwancheng.png",
        quxiaodingdan: "/static/img/center_quxiaodingdan.png",
        daipingjia: "/static/img/center_daipingjia.png"
      },
      fixed: false,
      member: [],
      member_order: [],
      is_tech: 0,
      is_store: 0,
      totalyiguanbi: 0,
      totaldaifukuan: 0,
      totaldaifuwu: 0,
      totaldaijiedan: 0,
      totalyiwancheng: 0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get_member();
      this.get_member_order();
    },
    get_member() {
      this.axios({
        url: this.api.member.get_member, 
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.member = res.member;
          this.is_tech = res.is_tech;
          this.is_store = res.is_store;
        }
      });
    },
    get_member_order() {
      this.axios({
        url: this.api.order.get_member_order, //获取用户订单
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.member_order = res.member_orders;
          this.totalyiguanbi = res.totalyiguanbi;
          this.totaldaifukuan = res.totaldaifukuan;
          this.totaldaifuwu = res.totaldaifuwu;
          this.totalyiwancheng = res.totalyiwancheng;
          this.totaldaijiedan = res.totaldaijiedan;
        }
      });
    }
  }
};
</script>

<style scoped>
.van-cell{
  padding:.7rem .75rem;
}
.member_box {
  position: relative;
}
.member_info {
  position: absolute;
  top: 10%;
  left: 0;
  width: 100%;
  text-align: center;
  /* padding-top: 1.5rem; */
  font-size: 0.9rem;
  color: #f2f2f2;
}
.member_info img {
  margin: 0 auto;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  margin-bottom: 0.3rem;
}
.member_level {
  font-size: 0.6rem;
}
.m_order {
  background-color: #ffffff;
}
.m_order_label {
  padding: 0.5rem 0.75rem 0.4rem;
  font-size: 0.75rem;
  color: #4e4f4f;
  border-bottom: 1px solid rgba(231, 231, 231, 0.5);
}
.m_order_label span {
  font-size: 0.6rem;
  color: #949595;
  position: absolute;
  right: 0.75rem;
}
.van-tabbar-item__icon img {
  width: 1.2rem;
  height: 1.2rem;
}
.m_order_status {
  background-color: white;
  padding: 0.5rem 1rem;
  font-size: 0.6rem;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.icon-jilu,
.icon-tuijianren {
  font-size: 1rem !important;
}
.van-cell .iconfont {
  margin-right: 0.5rem;
  font-size: 1.2rem;
  width: 1.2rem;
  line-height: 1.2rem;
  height: 1.2rem;
  text-align: center;
}
.enter_apply {
  margin: 0.5rem 0.5rem 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/views/center/center.vue